import { useState } from "react";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import { useNavigate } from "react-router-dom";
import LoginEmail from "../../../layout/LoginEmail";
import LoginVerify from "../../../layout/LoginVerify";
import { useAuth } from "../../../contexts/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { sendOTPAsync } from "../../../lib/service/otp/sendOTPSlice";
import { verifyOTPAsync } from "../../../lib/service/otp/verifyOTPSlice";
import { useOtp } from "../../../contexts/OtpContext";

function SubscribeReservation({
  email,
  setEmail,
  error,
  setError,
  handleInputChange,
}) {
  const [showModal, setShowModal] = useState("login");
  const { login } = useAuth();
  const { otp } = useOtp();
  const otpString = Object.values(otp).join("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sendOTPState = useSelector((state) => state.sendOTP);
  const verifyOTPState = useSelector((state) => state.verifyOTP);
  const handleButtonClick = () => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    if (!emailPattern.test(email)) {
      setError("Please enter a valid email address.");
    } else if (email) {
      // Dispatch sendOTPAsync if email is valid
      dispatch(sendOTPAsync({ email }))
        .unwrap()
        .then(() => {
          login();
          navigate("/verification", { state: { status: true } });
          onClick();
        })
        .catch((error) => {
          console.log("error", error);
          console.error("Error sending OTP:", error);
          setError(error?.message);
        });
    } else {
    }
  };

  return (
    <div className="leap-text-white leap-flex leap-flex-col leap-gap-7">
      <div className="leap-gap-5 leap-flex leap-justify-center leap-px-2">
        <span className="leap-mt-auto">From </span>
        <span className="leap-text-[#73FAFD] leap-text-[20px] sm:leap-text-[24px] md:leap-text-[30px] lg:leap-text-[36px] xl:leap-text-[40px]  leap-leading-[33px] leap-font-bold">
          February 9th
        </span>
        <span className="leap-mt-auto">To </span>
        <span className="leap-text-[#73FAFD] leap-text-[20px] sm:leap-text-[24px] md:leap-text-[30px] lg:leap-text-[36px] xl:leap-text-[40px]  leap-leading-[33px] leap-font-bold">
          February 12th
        </span>
      </div>
      <h1 className="leap-text-[16px] sm:leap-text-[20px] md:leap-text-[26px] lg:leap-text-[32px] xl:leap-text-[36px] leap-leading-[33px] leap-font-bold">
        Book Your Tour Now
      </h1>
      <div className="leap-flex-col  md:leap-flex-row leap-flex leap-gap-4 leap-justify-center">
        {showModal === "login" && (
          <LoginEmail
            email={email}
            error={error}
            handleInputChange={handleInputChange}
            handleButtonClick={handleButtonClick}
          />
        )}
      </div>
    </div>
  );
}

export default SubscribeReservation;
